import domain from './domain';
import { resetClientTeamMembers, resetClientTeamParticipationList } from './events';
import { CollectionResource } from 'dy-frontend-http-repository/lib/data/resources';
import {
    UserSpaceParticipationResource,
    UserSpaceResource,
} from 'dy-frontend-http-repository/lib/modules/UserSpace/resources';

// List of users, participating in the team of the current client
export const $clientTeamMembers = domain
    .createStore<CollectionResource<UserSpaceParticipationResource, {}> | null>(null)
    .reset(resetClientTeamMembers);

// List of user spaces where client acts as a participant
export const $clientTeamParticipationList = domain
    .createStore<CollectionResource<UserSpaceResource, {}> | null>(null)
    .reset(resetClientTeamParticipationList);
